import moment from 'moment';
const dateFormat = 'MM/DD/YYYY';

export const isDateHigherThan = (dateStr) => (value) => {
  const date = moment(dateStr, dateFormat, true);
  const dateSent = moment(value, dateFormat, true);
  if (value && date && dateSent && dateSent <= date) {
    return `Date entered should be later than ${dateStr}`;
  }
  return undefined;
};

export default isDateHigherThan;
